(() => {
  'use strict';

  const configElement = document.getElementById('BamburiDeliveryConfig');
  if (!configElement || window.BamburiDeliveryAssistant) return;

  let config;
  try {
    config = JSON.parse(configElement.textContent);
  } catch (error) {
    console.warn('[Bamburi] Delivery configuration could not be read.', error);
    return;
  }

  const copy = {
    en: {
      title: 'Language and delivery destination', country: 'Delivery country', area: 'Delivery area', language: 'Language',
      continue: 'Continue', close: 'Close', change: 'Change', currentDestination: 'Deliver to {destination}',
      shippingEmpty: '{destination}: free shipping on orders of {threshold} or more.',
      shippingRemaining: '{destination}: add {amount} to unlock free shipping.',
      shippingReached: '{destination}: free shipping unlocked.',
      checkoutNote: 'Your checkout address determines the final shipping charge.',
      fallback: 'The final shipping charge is confirmed at checkout.',
      ceutaMelilla: 'We do not currently ship to Ceuta or Melilla.',
      ptMainland: 'Mainland Portugal', ptIslands: 'Madeira and the Azores', esMainland: 'Mainland Spain',
      esBalearic: 'Balearic Islands', esCanary: 'Canary Islands'
    },
    pt: {
      title: 'Idioma e destino de entrega', country: 'País de entrega', area: 'Zona de entrega', language: 'Idioma',
      continue: 'Continuar', close: 'Fechar', change: 'Alterar', currentDestination: 'Entregar em {destination}',
      shippingEmpty: '{destination}: portes grátis a partir de {threshold}.',
      shippingRemaining: '{destination}: faltam {amount} para portes grátis.',
      shippingReached: '{destination}: portes grátis alcançados.',
      checkoutNote: 'A morada indicada no checkout determina os portes finais.',
      fallback: 'O valor final dos portes é confirmado no checkout.',
      ceutaMelilla: 'De momento, não efetuamos envios para Ceuta ou Melilla.',
      ptMainland: 'Portugal continental', ptIslands: 'Madeira e Açores', esMainland: 'Espanha continental',
      esBalearic: 'Baleares', esCanary: 'Canárias'
    },
    es: {
      title: 'Idioma y destino de entrega', country: 'País de entrega', area: 'Zona de entrega', language: 'Idioma',
      continue: 'Continuar', close: 'Cerrar', change: 'Cambiar', currentDestination: 'Enviar a {destination}',
      shippingEmpty: '{destination}: envío gratis a partir de {threshold}.',
      shippingRemaining: '{destination}: faltan {amount} para conseguir el envío gratis.',
      shippingReached: '{destination}: envío gratis conseguido.',
      checkoutNote: 'La dirección indicada en el checkout determina los gastos de envío finales.',
      fallback: 'Los gastos de envío finales se confirman en el checkout.',
      ceutaMelilla: 'Actualmente no realizamos envíos a Ceuta ni Melilla.',
      ptMainland: 'Portugal continental', ptIslands: 'Madeira y Azores', esMainland: 'España peninsular',
      esBalearic: 'Islas Baleares', esCanary: 'Islas Canarias'
    },
    fr: {
      title: 'Langue et destination de livraison', country: 'Pays de livraison', area: 'Zone de livraison', language: 'Langue',
      continue: 'Continuer', close: 'Fermer', change: 'Modifier', currentDestination: 'Livrer à {destination}',
      shippingEmpty: '{destination} : livraison offerte dès {threshold}.',
      shippingRemaining: '{destination} : plus que {amount} pour bénéficier de la livraison offerte.',
      shippingReached: '{destination} : livraison offerte débloquée.',
      checkoutNote: 'L’adresse indiquée lors du paiement détermine les frais de livraison définitifs.',
      fallback: 'Les frais de livraison définitifs sont confirmés lors du paiement.',
      ceutaMelilla: 'Nous ne livrons actuellement ni à Ceuta ni à Melilla.',
      ptMainland: 'Portugal continental', ptIslands: 'Madère et Açores', esMainland: 'Espagne péninsulaire',
      esBalearic: 'Îles Baléares', esCanary: 'Îles Canaries'
    },
    de: {
      title: 'Sprache und Lieferziel', country: 'Lieferland', area: 'Liefergebiet', language: 'Sprache',
      continue: 'Weiter', close: 'Schließen', change: 'Ändern', currentDestination: 'Lieferung nach {destination}',
      shippingEmpty: '{destination}: kostenloser Versand ab {threshold}.',
      shippingRemaining: '{destination}: noch {amount} bis zum kostenlosen Versand.',
      shippingReached: '{destination}: kostenloser Versand freigeschaltet.',
      checkoutNote: 'Die Adresse im Checkout bestimmt die endgültigen Versandkosten.',
      fallback: 'Die endgültigen Versandkosten werden im Checkout bestätigt.',
      ceutaMelilla: 'Wir liefern derzeit nicht nach Ceuta oder Melilla.',
      ptMainland: 'Portugiesisches Festland', ptIslands: 'Madeira und Azoren', esMainland: 'Spanisches Festland',
      esBalearic: 'Balearen', esCanary: 'Kanarische Inseln'
    },
    it: {
      title: 'Lingua e destinazione di consegna', country: 'Paese di consegna', area: 'Zona di consegna', language: 'Lingua',
      continue: 'Continua', close: 'Chiudi', change: 'Modifica', currentDestination: 'Consegna a {destination}',
      shippingEmpty: '{destination}: spedizione gratuita per ordini a partire da {threshold}.',
      shippingRemaining: '{destination}: mancano {amount} alla spedizione gratuita.',
      shippingReached: '{destination}: spedizione gratuita attivata.',
      checkoutNote: 'L’indirizzo inserito al checkout determina il costo finale della spedizione.',
      fallback: 'Il costo finale della spedizione viene confermato al checkout.',
      ceutaMelilla: 'Al momento non effettuiamo spedizioni a Ceuta o Melilla.',
      ptMainland: 'Portogallo continentale', ptIslands: 'Madeira e Azzorre', esMainland: 'Spagna peninsulare',
      esBalearic: 'Isole Baleari', esCanary: 'Isole Canarie'
    },
    nl: {
      title: 'Taal en bezorgbestemming', country: 'Bezorgland', area: 'Bezorgregio', language: 'Taal',
      continue: 'Doorgaan', close: 'Sluiten', change: 'Wijzigen', currentDestination: 'Bezorgen in {destination}',
      shippingEmpty: '{destination}: gratis verzending vanaf {threshold}.',
      shippingRemaining: '{destination}: nog {amount} tot gratis verzending.',
      shippingReached: '{destination}: gratis verzending ontgrendeld.',
      checkoutNote: 'Het adres bij het afrekenen bepaalt de uiteindelijke verzendkosten.',
      fallback: 'De uiteindelijke verzendkosten worden bij het afrekenen bevestigd.',
      ceutaMelilla: 'We verzenden momenteel niet naar Ceuta of Melilla.',
      ptMainland: 'Vasteland van Portugal', ptIslands: 'Madeira en de Azoren', esMainland: 'Vasteland van Spanje',
      esBalearic: 'Balearen', esCanary: 'Canarische Eilanden'
    },
    pl: {
      title: 'Język i miejsce dostawy', country: 'Kraj dostawy', area: 'Region dostawy', language: 'Język',
      continue: 'Kontynuuj', close: 'Zamknij', change: 'Zmień', currentDestination: 'Dostawa do {destination}',
      shippingEmpty: '{destination}: bezpłatna dostawa od {threshold}.',
      shippingRemaining: '{destination}: brakuje {amount} do bezpłatnej dostawy.',
      shippingReached: '{destination}: bezpłatna dostawa została odblokowana.',
      checkoutNote: 'Adres podany przy realizacji zamówienia określa ostateczny koszt dostawy.',
      fallback: 'Ostateczny koszt dostawy jest potwierdzany przy realizacji zamówienia.',
      ceutaMelilla: 'Obecnie nie wysyłamy zamówień do Ceuty ani Melilli.',
      ptMainland: 'Portugalia kontynentalna', ptIslands: 'Madera i Azory', esMainland: 'Hiszpania kontynentalna',
      esBalearic: 'Baleary', esCanary: 'Wyspy Kanaryjskie'
    },
    da: {
      title: 'Sprog og leveringssted', country: 'Leveringsland', area: 'Leveringsområde', language: 'Sprog',
      continue: 'Fortsæt', close: 'Luk', change: 'Skift', currentDestination: 'Levering til {destination}',
      shippingEmpty: '{destination}: gratis levering fra {threshold}.',
      shippingRemaining: '{destination}: kun {amount} tilbage til gratis levering.',
      shippingReached: '{destination}: gratis levering aktiveret.',
      checkoutNote: 'Adressen ved checkout bestemmer den endelige fragtpris.',
      fallback: 'Den endelige fragtpris bekræftes ved checkout.',
      ceutaMelilla: 'Vi leverer i øjeblikket ikke til Ceuta eller Melilla.',
      ptMainland: 'Portugals fastland', ptIslands: 'Madeira og Azorerne', esMainland: 'Spaniens fastland',
      esBalearic: 'Balearerne', esCanary: 'De Kanariske Øer'
    },
    sv: {
      title: 'Språk och leveransdestination', country: 'Leveransland', area: 'Leveransområde', language: 'Språk',
      continue: 'Fortsätt', close: 'Stäng', change: 'Ändra', currentDestination: 'Leverans till {destination}',
      shippingEmpty: '{destination}: fri frakt från {threshold}.',
      shippingRemaining: '{destination}: bara {amount} kvar till fri frakt.',
      shippingReached: '{destination}: fri frakt upplåst.',
      checkoutNote: 'Adressen i kassan avgör den slutliga fraktkostnaden.',
      fallback: 'Den slutliga fraktkostnaden bekräftas i kassan.',
      ceutaMelilla: 'Vi levererar för närvarande inte till Ceuta eller Melilla.',
      ptMainland: 'Portugals fastland', ptIslands: 'Madeira och Azorerna', esMainland: 'Spaniens fastland',
      esBalearic: 'Balearerna', esCanary: 'Kanarieöarna'
    },
    ja: {
      title: '言語と配送先', country: '配送先の国', area: '配送地域', language: '言語',
      continue: '続ける', close: '閉じる', change: '変更', currentDestination: '配送先：{destination}',
      shippingEmpty: '{destination}：{threshold}以上のご注文で送料無料です。',
      shippingRemaining: '{destination}：送料無料まであと{amount}です。',
      shippingReached: '{destination}：送料無料が適用されました。',
      checkoutNote: '購入手続きで入力した住所に基づいて最終的な送料が決まります。',
      fallback: '最終的な送料は購入手続き時に確認できます。',
      ceutaMelilla: '現在、セウタおよびメリリャへの配送は承っておりません。',
      ptMainland: 'ポルトガル本土', ptIslands: 'マデイラ諸島・アゾレス諸島', esMainland: 'スペイン本土',
      esBalearic: 'バレアレス諸島', esCanary: 'カナリア諸島'
    },
    ko: {
      title: '언어 및 배송지', country: '배송 국가', area: '배송 지역', language: '언어',
      continue: '계속', close: '닫기', change: '변경', currentDestination: '배송지: {destination}',
      shippingEmpty: '{destination}: {threshold} 이상 주문 시 무료 배송',
      shippingRemaining: '{destination}: 무료 배송까지 {amount} 남았습니다.',
      shippingReached: '{destination}: 무료 배송이 적용되었습니다.',
      checkoutNote: '결제 시 입력한 주소에 따라 최종 배송비가 결정됩니다.',
      fallback: '최종 배송비는 결제 단계에서 확인됩니다.',
      ceutaMelilla: '현재 세우타 및 멜리야 지역으로는 배송하지 않습니다.',
      ptMainland: '포르투갈 본토', ptIslands: '마데이라 및 아조레스 제도', esMainland: '스페인 본토',
      esBalearic: '발레아레스 제도', esCanary: '카나리아 제도'
    }
  };

  const STORAGE_KEY = 'bamburi_delivery_preferences_v1';
  const LEGACY_SESSION_KEY = 'bamburi_delivery_session_v1';
  const DISMISS_KEY = 'bamburi_delivery_dismissed_v1';
  const TRANSIENT_REGION_PARAM = 'bamburi_delivery_region';
  const VALID_REGIONS = {
    PT: ['pt-mainland', 'pt-islands'],
    ES: ['es-mainland', 'es-balearic', 'es-canary']
  };
  const MAX_AGE = 180 * 24 * 60 * 60 * 1000;
  const DISMISS_AGE = 7 * 24 * 60 * 60 * 1000;
  const languageCode = String(config.activeLanguage || document.documentElement.lang || 'en').toLowerCase().split('-')[0];
  const strings = copy[languageCode] || copy.en;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const assistant = document.querySelector('[data-bamburi-delivery-assistant]');
  const panel = assistant && assistant.querySelector('[data-bamburi-destination-panel]');
  const countrySelect = assistant && assistant.querySelector('[data-bamburi-country]');
  const languageSelect = assistant && assistant.querySelector('[data-bamburi-language]');
  const localizationForm = assistant && assistant.querySelector('form');
  let cartState = {
    total_price: Number(config.cartTotal) || 0,
    item_count: Number(config.itemCount) || 0,
    requires_shipping: config.requiresShipping
  };
  let memoryRegions = {};
  let cartRequest = null;
  let cartTimer = null;
  let cartFinalTimer = null;
  let cartRefreshPending = false;
  let cartUnavailable = false;
  let lastTrigger = null;
  let privacyState = 'unknown';
  let confirmedInMemory = false;
  let dismissedInMemory = false;
  let interfaceInitialised = false;
  let autoOpenTimer = null;
  let transientRegionApplied = false;

  const interpolate = (template, values) => String(template).replace(/\{(\w+)\}/g, (_, key) => values[key] ?? '');

  const canPersistPreferences = () => privacyState === 'allowed';

  const safeParse = (value) => {
    try { return value ? JSON.parse(value) : null; } catch (_) { return null; }
  };

  const readStoredPreferences = () => {
    if (!canPersistPreferences()) return null;
    let value = null;
    try { value = safeParse(localStorage.getItem(STORAGE_KEY)); } catch (_) {}
    if (!value || value.version !== 1) return null;
    if (value.expiresAt && value.expiresAt < Date.now()) {
      try { localStorage.removeItem(STORAGE_KEY); } catch (_) {}
      return null;
    }
    return value;
  };

  const writePreferences = () => {
    confirmedInMemory = true;
    if (!canPersistPreferences()) return;
    const value = {
      version: 1,
      regions: memoryRegions,
      confirmedAt: Date.now(),
      expiresAt: Date.now() + MAX_AGE
    };
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(value)); } catch (_) {}
  };

  const hasDismissedRecently = () => {
    if (dismissedInMemory) return true;
    if (!canPersistPreferences()) return false;
    try {
      const value = Number(localStorage.getItem(DISMISS_KEY));
      return Number.isFinite(value) && Date.now() - value < DISMISS_AGE;
    } catch (_) { return false; }
  };

  const rememberDismissal = () => {
    dismissedInMemory = true;
    if (canPersistPreferences()) {
      try { localStorage.setItem(DISMISS_KEY, String(Date.now())); } catch (_) {}
    }
  };

  const clearPersistedPreferences = () => {
    try {
      localStorage.removeItem(STORAGE_KEY);
      localStorage.removeItem(DISMISS_KEY);
      sessionStorage.removeItem(LEGACY_SESSION_KEY);
      sessionStorage.removeItem(DISMISS_KEY);
    } catch (_) {}
  };

  const applyCopy = () => {
    document.querySelectorAll('[data-bamburi-copy]').forEach((element) => {
      const value = strings[element.dataset.bamburiCopy];
      if (value) element.textContent = value;
    });
    if (panel) {
      const close = panel.querySelector('[data-bamburi-close-destination]');
      if (close) close.setAttribute('aria-label', strings.close);
    }
  };

  const regionDefault = (country) => country === 'PT' ? 'pt-mainland' : country === 'ES' ? 'es-mainland' : '';

  const validRegion = (country, region) => Boolean(
    VALID_REGIONS[country] && VALID_REGIONS[country].includes(region)
  );

  const updateLocalizationReturnTo = (country, region) => {
    const regionIsValid = validRegion(country, region);
    let returnTo = localizationForm && localizationForm.querySelector('input[name="return_to"]');
    if (!returnTo && !regionIsValid) return;
    if (!returnTo) {
      returnTo = document.createElement('input');
      returnTo.type = 'hidden';
      returnTo.name = 'return_to';
      localizationForm.appendChild(returnTo);
    }
    try {
      const fallback = `${window.location.pathname}${window.location.search}${window.location.hash}`;
      const url = new URL(returnTo.value || fallback, window.location.origin);
      url.searchParams.delete(TRANSIENT_REGION_PARAM);
      if (regionIsValid) url.searchParams.set(TRANSIENT_REGION_PARAM, region);
      returnTo.value = `${url.pathname}${url.search}${url.hash}`;
    } catch (_) {}
  };

  const applyTransientRegion = () => {
    try {
      const url = new URL(window.location.href);
      const country = String(config.activeCountry || '').toUpperCase();
      const region = url.searchParams.get(TRANSIENT_REGION_PARAM);
      if (validRegion(country, region)) {
        memoryRegions[country] = region;
        confirmedInMemory = true;
        transientRegionApplied = true;
      }
      if (region !== null) {
        url.searchParams.delete(TRANSIENT_REGION_PARAM);
        window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
        updateLocalizationReturnTo('', '');
      }
    } catch (_) {}
  };

  const selectedRegion = (country) => {
    const select = assistant && assistant.querySelector(`[data-bamburi-region="${country}"]`);
    if (select && !select.closest('[hidden]')) return select.value;
    return memoryRegions[country] || regionDefault(country);
  };

  const showRegionFields = (country) => {
    if (!assistant) return;
    assistant.querySelectorAll('[data-bamburi-region-group]').forEach((group) => {
      const active = group.dataset.bamburiRegionGroup === country;
      group.hidden = !active;
      const select = group.querySelector('select');
      if (select) {
        select.disabled = !active;
        if (active) select.value = memoryRegions[country] || regionDefault(country);
      }
    });
  };

  const cleanCountryName = (option) => (option ? option.textContent : '')
    .replace(/\s*\([A-Z]{3}\)\s*$/, '')
    .trim();

  const countryName = (country) => {
    const option = countrySelect && countrySelect.querySelector(`option[value="${country}"]`);
    return cleanCountryName(option) || country;
  };

  const destinationName = (country, region) => {
    if (country === 'PT') return region === 'pt-islands' ? strings.ptIslands : strings.ptMainland;
    if (country === 'ES') {
      if (region === 'es-balearic') return strings.esBalearic;
      if (region === 'es-canary') return strings.esCanary;
      return strings.esMainland;
    }
    return countryName(country);
  };

  const currentCountry = () => String(config.activeCountry || (countrySelect && countrySelect.value) || '').toUpperCase();

  const thresholdFor = (country, region) => {
    const values = config.thresholds || {};
    if (country === 'PT') return Number(region === 'pt-islands' ? values.PT_ISLANDS : values.PT_MAINLAND);
    if (country === 'ES') return Number(values.ES);
    if (country === 'US') return Number(values.US);
    if (country === 'CA') return Number(values.CA);
    if ((config.europeCountries || []).includes(country)) return Number(values.EUROPE);
    return Number(values.REST_WORLD);
  };

  const formatMoney = (minorUnits) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || languageCode, {
        style: 'currency', currency: config.currency, maximumFractionDigits: 2
      }).format(Number(minorUnits) / 100);
    } catch (_) {
      return `${(Number(minorUnits) / 100).toFixed(2)} ${config.currency || ''}`.trim();
    }
  };

  const updateCurrentDestination = () => {
    const country = currentCountry();
    const destination = destinationName(country, selectedRegion(country));
    document.querySelectorAll('.bamburi-delivery-trigger').forEach((trigger) => trigger.toggleAttribute('hidden', confirmedInMemory || privacyState === 'unknown'));
    document.querySelectorAll('[data-bamburi-current-destination]').forEach((element) => {
      element.textContent = interpolate(strings.currentDestination, { destination });
    });
  };

  const updateProgress = () => {
    const country = currentCountry();
    const region = selectedRegion(country);
    const destination = destinationName(country, region);
    const threshold = thresholdFor(country, region);
    const total = Number(cartState.total_price) || 0;
    const itemCount = Number(cartState.item_count) || 0;
    let requiresShipping = itemCount === 0;
    if (itemCount > 0) {
      if (typeof cartState.requires_shipping === 'boolean') {
        requiresShipping = cartState.requires_shipping;
      } else if (Array.isArray(cartState.items)) {
        requiresShipping = cartState.items.some((item) => item.requires_shipping !== false);
      } else {
        requiresShipping = true;
      }
    }

    document.querySelectorAll('[data-bamburi-shipping-progress]').forEach((component) => {
      component.querySelectorAll('[data-bamburi-copy]').forEach((element) => element.textContent = strings[element.dataset.bamburiCopy] || element.textContent);
      const message = component.querySelector('[data-bamburi-shipping-message]');
      const track = component.querySelector('[data-bamburi-shipping-track]');
      const value = component.querySelector('[data-bamburi-shipping-value]');
      if (!message || !track || !value || !requiresShipping) {
        component.hidden = true;
        return;
      }

      component.hidden = false;
      if (cartUnavailable) {
        message.textContent = strings.fallback;
        track.hidden = true;
        return;
      }
      if (!Number.isFinite(threshold) || threshold <= 0) {
        message.textContent = strings.fallback;
        track.hidden = true;
        return;
      }

      track.hidden = false;
      let percentage = 0;
      if (itemCount === 0) {
        message.textContent = interpolate(strings.shippingEmpty, {
          destination, threshold: formatMoney(threshold)
        });
      } else if (total >= threshold) {
        percentage = 100;
        message.textContent = interpolate(strings.shippingReached, { destination });
      } else {
        percentage = Math.min(100, Math.max(0, total / threshold * 100));
        message.textContent = interpolate(strings.shippingRemaining, {
          destination, amount: formatMoney(threshold - total)
        });
      }

      value.style.transform = `scaleX(${percentage / 100})`;
      track.setAttribute('aria-valuenow', String(Math.round(percentage)));
      track.setAttribute('aria-label', message.textContent);
    });
  };

  const updateAll = () => {
    applyCopy();
    updateCurrentDestination();
    updateProgress();
  };

  const openPanel = (trigger, moveFocus = true) => {
    if (!panel || !countrySelect) return;
    if (trigger) lastTrigger = trigger;
    panel.setAttribute('role', moveFocus ? 'dialog' : 'region');
    if (moveFocus) panel.setAttribute('aria-modal', 'false');
    else panel.removeAttribute('aria-modal');
    showRegionFields(countrySelect.value);
    panel.hidden = false;
    document.querySelectorAll('[data-bamburi-open-destination]').forEach((button) => button.setAttribute('aria-expanded', 'true'));
    if (moveFocus) countrySelect.focus({ preventScroll: true });
  };

  const closePanel = (remember = false) => {
    if (!panel) return;
    panel.hidden = true;
    panel.setAttribute('role', 'region');
    panel.removeAttribute('aria-modal');
    document.querySelectorAll('[data-bamburi-open-destination]').forEach((button) => button.setAttribute('aria-expanded', 'false'));
    if (remember) rememberDismissal();
    if (lastTrigger && document.contains(lastTrigger) && !panel.contains(lastTrigger) && typeof lastTrigger.focus === 'function') {
      lastTrigger.focus({ preventScroll: true });
    }
  };

  const applyCartState = (cart) => {
    if (!cart || typeof cart.total_price !== 'number' || typeof cart.item_count !== 'number') return false;
    cartState = cart;
    cartUnavailable = false;
    if (cart.currency) config.currency = cart.currency;
    updateProgress();
    return true;
  };

  const refreshCart = async (providedCart) => {
    if (applyCartState(providedCart)) return providedCart;
    if (cartRequest) {
      cartRefreshPending = true;
      return cartRequest;
    }
    cartRequest = fetch(`${root}cart.js`, {
      headers: { Accept: 'application/json' }, credentials: 'same-origin'
    })
      .then((response) => {
        if (!response.ok) throw new Error('Cart request failed');
        return response.json();
      })
      .then((cart) => {
        applyCartState(cart);
        return cart;
      })
      .catch(() => {
        cartUnavailable = true;
        updateProgress();
        return null;
      })
      .finally(() => {
        cartRequest = null;
        if (cartRefreshPending) {
          cartRefreshPending = false;
          setTimeout(() => refreshCart(), 0);
        }
      });
    return cartRequest;
  };

  const scheduleCartRefresh = (delay = 120) => {
    clearTimeout(cartTimer);
    cartTimer = setTimeout(refreshCart, delay);
  };

  const scheduleSettledCartRefresh = (delay = 300) => {
    scheduleCartRefresh(delay);
    clearTimeout(cartFinalTimer);
    cartFinalTimer = setTimeout(refreshCart, delay + 1000);
  };

  const autoOpen = () => {
    if (!panel || confirmedInMemory || readStoredPreferences() || hasDismissedRecently()) return;
    if (!canPersistPreferences()) return;
    clearTimeout(autoOpenTimer);
    autoOpenTimer = setTimeout(() => {
      if (!panel.hidden || confirmedInMemory || readStoredPreferences() || hasDismissedRecently()) return;
      openPanel(null, false);
    }, 800);
  };

  const initialisePrivacy = () => {
    const refreshInterface = () => {
      const stored = readStoredPreferences();
      if (stored && stored.regions) {
        memoryRegions = { ...stored.regions, ...memoryRegions };
        confirmedInMemory = true;
      }
      if (transientRegionApplied && canPersistPreferences()) {
        writePreferences();
        transientRegionApplied = false;
      }
      showRegionFields(currentCountry());
      updateAll();
      autoOpen();
    };

    const initialiseInterface = () => {
      if (!interfaceInitialised) interfaceInitialised = true;
      refreshInterface();
    };

    initialiseInterface();
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      const fallback = setTimeout(() => {
        if (privacyState === 'unknown') {
          privacyState = 'denied';
          clearPersistedPreferences();
          initialiseInterface();
        }
      }, 1500);
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        clearTimeout(fallback);
        try {
          privacyState = !error && window.Shopify.customerPrivacy.preferencesProcessingAllowed() ? 'allowed' : 'denied';
        } catch (_) {
          privacyState = 'denied';
        }
        if (privacyState === 'denied') clearPersistedPreferences();
        initialiseInterface();
      });
    } else {
      privacyState = 'denied';
      clearPersistedPreferences();
      initialiseInterface();
    }
  };

  document.addEventListener('click', (event) => {
    const open = event.target.closest('[data-bamburi-open-destination]');
    if (open) {
      event.preventDefault();
      const drawerClose = open.closest('cart-drawer.active, #Cart-Drawer.active')?.querySelector('.side-panel-close');
      if (drawerClose) drawerClose.click();
      if (drawerClose) setTimeout(() => openPanel(document.querySelector('#cart-drawer-toggle'), true), 350);
      else openPanel(open, true);
      return;
    }
    const close = event.target.closest('[data-bamburi-close-destination]');
    if (close) {
      event.preventDefault();
      closePanel(true);
      return;
    }
    if (event.target.closest('cart-remove, [data-cart-remove], .cart-remove, a[href*="/cart/change"]')) {
      scheduleSettledCartRefresh(500);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && panel && !panel.hidden) closePanel(true);
  });

  if (countrySelect) {
    countrySelect.addEventListener('change', () => showRegionFields(countrySelect.value));
  }

  if (localizationForm) {
    localizationForm.addEventListener('submit', (event) => {
      const country = countrySelect.value;
      const region = selectedRegion(country);
      if (validRegion(country, region)) memoryRegions[country] = region;
      writePreferences();
      dismissedInMemory = false;
      if (canPersistPreferences()) {
        try { localStorage.removeItem(DISMISS_KEY); } catch (_) {}
      }

      const countryUnchanged = country === config.activeCountry;
      const languageUnchanged = !languageSelect || languageSelect.value === config.activeLanguage;
      if (countryUnchanged && languageUnchanged) {
        event.preventDefault();
        config.activeCountry = country;
        closePanel(false);
        updateAll();
      } else {
        updateLocalizationReturnTo(country, region);
      }
    });
  }

  document.addEventListener('visitorConsentCollected', () => {
    try {
      privacyState = window.Shopify.customerPrivacy.preferencesProcessingAllowed() ? 'allowed' : 'denied';
    } catch (_) {
      privacyState = 'denied';
    }
    if (!canPersistPreferences()) {
      clearPersistedPreferences();
      return;
    }
    if (confirmedInMemory) writePreferences();
    autoOpen();
  });

  ['cart:updated', 'cart:refresh', 'cart:change', 'shopify:cart:lines-update', 'shopify:cart:discount-update',
    'bamburi:cart-updated', 'theme:cart:change'].forEach((name) => {
    document.addEventListener(name, (event) => {
      const detail = event.detail;
      const suppliedCart = detail && (detail.cart || (typeof detail.total_price === 'number' ? detail : null));
      if (!applyCartState(suppliedCart)) scheduleCartRefresh();
    });
  });
  document.addEventListener('shopify:section:load', () => { applyCopy(); scheduleCartRefresh(); });
  window.addEventListener('pageshow', () => scheduleCartRefresh(0));
  document.addEventListener('change', (event) => {
    if (event.target.matches('input[name="updates[]"], input[name="quantity"], select[name="updates[]"]')) {
      scheduleSettledCartRefresh(400);
    }
  });
  document.addEventListener('submit', (event) => {
    const action = event.target && event.target.getAttribute && event.target.getAttribute('action');
    if (action && /\/cart\/(add|change|update)/.test(action)) scheduleSettledCartRefresh(700);
  }, true);

  applyTransientRegion();
  initialisePrivacy();
  refreshCart();

  window.BamburiDeliveryAssistant = { refreshCart, open: () => openPanel(null, true) };
})();

